<template>
  <div>
    <AppIconUpload />
    <hr class="divider" />

    <template v-if="app.cover">
      <AppCoverUpload />
      <hr class="divider" />
    </template>

    <AppScreenshots />
    <!-- <hr class="divider" />
    <AppPromoScreenshots /> -->
    <hr class="divider" />
    <AppVideoShots />
  </div>
</template>

<script>
import AppIconUpload from './AppIconUpload';
import AppCoverUpload from './AppCoverUpload';
import AppScreenshots from './AppScreenshots';
import AppVideoShots from './AppVideoShots';
import { APP_DETAILS } from '@/store/types';
import { mapGetters } from 'vuex';

export default {
  name: 'AppMedia',
  components: {
    AppIconUpload,
    AppCoverUpload,
    AppScreenshots,
    AppVideoShots,
  },
  computed: {
    ...mapGetters({ app: APP_DETAILS }),
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
}

.fade-enter-active {
  transition-duration: 0.4s;
}

.fade-leave-active {
  transition-duration: 0.1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
